<template lang="html">
   <div class="login-back">
      <div class="row">
         <div class="col-12 col-md-6 col-xl-7 image-back">
            <div class="overlay"></div>
            <!-- <div class="copyright t2-5 ">&copy; OakNet {{new Date().getFullYear()}}. All rights reserved</div> -->
            <div class="txt-box">
               <!-- <div class="txt">
                  Master Card Foundation is committed to the principle that humane and orderly migration benefits migrants and society.
               </div> -->
            </div>
         </div>
         <div class="col-12 col-md-6 col-xl-5">
            <div class="row justify-content-center">
               <div class="col-12 col-lg-11">
                  <div class="login">
                     <div class="logo-box">
                        <img :src="lang.logo" alt="" class="logo">
                     </div>

                     <div class="h3">{{lang.forgot}}</div>
                     <div class="text-muted t3-5 ">{{lang.forgot_sub}}</div>
                     
                     <div>
                        <Form 
                           classBinding="row form-box"
                           :ref="LogInModel.forms.verifyRegistrationToken.name" 
                           :forms="LogInModel.forms.verifyRegistrationToken.forms" 
                           :formData="LogInModel.forms.verifyRegistrationToken.data"
                        />
                        
                        <div class="btns">
                           <button class="btn btn-primary" :disabled="loading" @click="verifyForgotPassword({ref: $refs[LogInModel.forms.verifyRegistrationToken.name],router:$router})">
                              {{lang.change}} <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                           </button>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import login from "./login.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('login')
   },
   created(){
      utils.registerModule('login',login,this.$store)
   },
   components:{
      Form: () => import("clarks/components/form"),
   },
   computed: {
      ...mapGetters([
         'LogInModel',
         'loading',
         'lang',
         'showLogIn',
         'page'
      ])
   },
   methods: {
      ...mapActions([
         'verifyForgotPassword',
         'resetPassword',
         'validateOTP',
         'sendOtp',
         'resendOTP',
         'checkToken',
      ]),
   },
   mounted(){
      utils.registerModule('login',login,this.$store)
      this.checkToken(this.$route)
   }
}
</script>

<style lang="scss">
@import './styles/verify-forgot.scss'
</style>